import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { TableCell, TableRow } from '../../ui/table';
import type { DocumentType } from '../../../api/documentTypeApi';

export type { DocumentType };

interface DocumentTypeTableRowProps {
  documentType: DocumentType;
  categoryName: string;
  onEdit: (documentType: DocumentType) => void;
  onDelete: (documentType: DocumentType) => void;
}

export default function DocumentTypeTableRow({
  documentType,
  categoryName,
  onEdit,
  onDelete,
}: DocumentTypeTableRowProps) {
  return (
    <TableRow>
      <TableCell className="font-mono text-sm">{documentType.document_code}</TableCell>
      <TableCell className="font-medium">{documentType.document_name}</TableCell>
      <TableCell>{categoryName}</TableCell>
      <TableCell>
        <div className="flex flex-wrap gap-1">
          {(documentType.allowed_formats || []).slice(0, 3).map(f => (
            <Badge
              key={f}
              className="bg-white text-gray-700 border border-gray-500 text-xs font-medium"
            >
              {f}
            </Badge>
          ))}
        </div>
      </TableCell>
      <TableCell className="text-center">{documentType.max_file_size_mb || 5} MB</TableCell>
      <TableCell className="text-center">{documentType.is_mandatory ? '✓' : '-'}</TableCell>
      <TableCell>
        <Badge
          className={
            documentType.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
          }
        >
          {documentType.is_active ? 'Aktif' : 'Tidak Aktif'}
        </Badge>
      </TableCell>
      <TableCell>
        <div className="flex gap-2">
          <Button variant="ghost" size="icon" onClick={() => onEdit(documentType)}>
            <Edit className="w-4 h-4" />
          </Button>
          <Button variant="ghost" size="icon" onClick={() => onDelete(documentType)}>
            <Trash2 className="w-4 h-4 text-red-500" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
